<script>
	import PageFooter from "./components/PageFooter.svelte";
	import PageHeader from "./components/PageHeader.svelte";
	import Router from "./routes/Router.svelte";

	export let url = "";

	const basepath = window.basePath || "/";

	const disableSubmitOnEnter = (e) => {
		if (e.which != "13") return;

		if (e.target && e.target.type && e.target.type != "textarea") {
			e.preventDefault();
		}
	};
</script>

<svelte:head>
	<!-- Google Tag Manager -->
	<script>
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != "dataLayer" ? "&l=" + l : "";
			j.async = true;
			j.src = "https://ss-gtm.shine.com.au/gtm.js?id=" + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, "script", "dataLayer", "GTM-TW92CF2W");
	</script>
	<!-- End Google Tag Manager -->
</svelte:head>

<!-- Google Tag Manager (noscript) -->
<noscript>
	<!-- svelte-ignore a11y-missing-attribute -->
	<iframe
		src="https://ss-gtm.shine.com.au/ns.html?id=GTM-TW92CF2W"
		height="0"
		width="0"
		style="display:none;visibility:hidden"></iframe>
</noscript>
<!-- End Google Tag Manager (noscript) -->

<div class="page" on:keypress={(e) => disableSubmitOnEnter(e)}>
	<PageHeader></PageHeader>

	<main>
		<section>
			<div class="form-content container-fluid">
				<form novalidate autocomplete="off">
					<Router {url} {basepath}></Router>
				</form>
			</div>
		</section>
	</main>

	<PageFooter></PageFooter>
</div>

<style>
	:global(hr.primary) {
		border-top: 2px solid var(--color-primary);
		margin: 16px auto;
		opacity: 1;
	}

	.page section {
		width: 100%;
		padding: var(--spacing-section) 0;
		padding: 40px 0;
		background-color: var(--color-lightGrey);
		position: relative;
		z-index: 1;
	}

	.form-content {
		max-width: 1210px;
		width: 100%;
		max-width: 1440px;
		padding: 0px 30px;
		margin: 0px auto;
	}

	@media print {
		.page section {
			padding: 0;
		}
	}
</style>
